// extracted by mini-css-extract-plugin
module.exports = {"accordion":"customAccordion_accordion__3BmXJ","active":"customAccordion_active__a-vzf","panel":"customAccordion_panel__1eX2f"};